import React from "react";
import {
    ChevronLeft,
    ChevronRight
} from "lucide-react";

const Pagination = ({
    page = 0,
    totalPages = 1,
    pageSize = 10,
    totalItems = 0,
    onPageChange,
}) => {

    const from = totalItems === 0
        ? 0
        : page * pageSize + 1;

    const to = Math.min(
        (page + 1) * pageSize,
        totalItems
    );

    return (
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-6">

            {/* Información */}
            <div className="text-xs text-gray-600">
                Mostrando
                <span className="font-semibold">
                    {" "}
                    {from}-{to}
                </span>{" "}
                de{" "}
                <span className="font-semibold">
                    {totalItems}
                </span>{" "}
                registros
            </div>

            {/* Botones */}
            <div className="flex items-center gap-2">

                <button
                    disabled={page === 0}
                    onClick={() => onPageChange(page - 1)}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition"
                >
                    <ChevronLeft size={18} />
                    {/* <span>Anterior</span> */}
                </button>

                <span className="text-xs font-medium text-gray-700 px-2">
                    {page + 1} / {totalPages}
                </span>

                <button
                    disabled={page + 1 >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition"
                >
                    {/* <span>Siguiente</span> */}
                    <ChevronRight size={18} />
                </button>

            </div>

        </div>
    );
};

export default Pagination;